import { render, staticRenderFns } from "./assetStatusList.vue?vue&type=template&id=34c70311"
import script from "./assetStatusList.vue?vue&type=script&lang=js"
export * from "./assetStatusList.vue?vue&type=script&lang=js"
import style0 from "./assetStatusList.vue?vue&type=style&index=0&id=34c70311&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports